import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { ShieldCheck, Users, Award, Building2 } from "lucide-react";

export default function About() {
    return (
        <PageShell>
            <section className="bg-brand-navy text-white py-16 md:py-24">
                <div className="max-w-5xl mx-auto px-6 md:px-12">
                    <div className="text-xs uppercase tracking-[0.3em] text-brand-orange font-bold mb-4">Our Story</div>
                    <h1 className="font-heading text-4xl md:text-6xl font-black uppercase leading-[0.95]">Fort Wayne's full-service employment agency since 1953.</h1>
                </div>
            </section>
            <section className="max-w-4xl mx-auto px-6 md:px-12 py-16 space-y-6 text-slate-700 text-lg leading-relaxed">
                <p>In the ever-changing labor market and cultural climate, Tower Staffing has remained Fort Wayne's full-service employment agency since 1953. Our dedication to our clients' needs and our applicants' skills has proven to result in long-standing relationships.</p>
                <p>Tower Staffing is a service-oriented, goal-driven full-service employment agency. Our mission is to provide our clients with the service they deserve. We offer personal attention and tailored competitive service packages to resolve our clients' immediate and strategic encumbrances.</p>
                <p>Our professional staffing team provides staffing solutions while maintaining the strongest code of ethics and integrity. We take pride in the responsive service we deliver every day to our clients.</p>
            </section>
            <section className="bg-slate-50 py-16">
                <div className="max-w-5xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {[
                        { Icon: Building2, k: "70+ Years", v: "Serving Fort Wayne since 1953" },
                        { Icon: Users, k: "Family Owned", v: "Personal, owner-led recruiting" },
                        { Icon: ShieldCheck, k: "Strict Ethics", v: "No-call/no-show policy enforced" },
                        { Icon: Award, k: "Trusted Partner", v: "Long-standing client relationships" },
                    ].map(({ Icon, k, v }) => (
                        <div key={k} className="bg-white border-2 border-slate-200 p-6">
                            <Icon className="h-8 w-8 text-brand-orange" />
                            <div className="mt-3 font-heading text-xl font-black uppercase text-brand-navy">{k}</div>
                            <p className="text-sm text-slate-600 mt-2">{v}</p>
                        </div>
                    ))}
                </div>
            </section>
            <section className="max-w-4xl mx-auto px-6 md:px-12 py-16 text-center">
                <h2 className="font-heading text-3xl md:text-5xl font-black uppercase text-brand-navy">Work with us.</h2>
                <p className="mt-3 text-slate-600 text-lg">One unified application — no more guessing which category.</p>
                <Link to="/apply" className="mt-6 inline-block bg-brand-orange hover:bg-brand-navy text-white font-heading uppercase tracking-wider font-bold px-8 py-4 rounded-sm transition-colors" data-testid="about-apply-btn">Get Started</Link>
            </section>
        </PageShell>
    );
}
